/**
 * Copy this Args and interface to contract module
 */
import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Product } from '../Product'

@InputType()
export class ImportProductWithSpecArgs extends ActionArgs {
  @Field(() => String)
  rawContent: string
}

export interface IImportProductWithSpec extends IAction<Product, ImportProductWithSpecArgs> {}

export type ImportExportProductSpecValue = string | number | boolean | string[] | null | undefined
export type ImportExportProductSpec = {
  key: string
  unit: string
  value: ImportExportProductSpecValue
  rawValue?: string
  description?: string
  isChange?: boolean
}

export type ProductImportSchema = {
  description: string
  input: 'NumberInput' | 'TextInput' | 'MetadataValueSelect' | 'CheckboxInput'
  isPublic: boolean
  name: string
  inputProps?: {
    options?: {
      label: string
      value: string
    }[]
  }
}

export type ImportExportProductRecord = Record<string, ProductImportSchema>

export const ImportProductActionMappingFields = {
  update_Quantity: 'update_Quantity',
  create_SubAssembly: 'create_SubAssembly',
  include_SubAssembly: 'include_SubAssembly',
}

export const ImportExportProductMappingFields = {
  code: 'code',
  name: 'name',
  price: 'price',
  status: 'status',
  fullDescription: 'fullDescription',
  summary: 'summary',
  forSale: 'forSale',
  coverImage: 'coverImage',
  tags: 'tags',
  remarks: 'remarks',
}

export const ImportExportDefaultMetadataKeysMappingFields = {
  weightOunce: 'weightOunce',
  shippingWeight: 'shippingWeight',
  weightPounds: 'weightPounds',
  category: 'category',
  dieSetType: 'dieSetType',
  horizontalIn: 'horizontalIn',
  horizontalMm: 'horizontalMm',
  shape: 'shape',
  verticalIn: 'verticalIn',
  verticalMm: 'verticalMm',
}
